export const isPlaywrightEnvironment = () => process.env['NEXT_PUBLIC_PLAYWRIGHT'] === 'true';
